import { RedirectCommand, ResolveFn } from '@angular/router';
import { inject } from '@angular/core';

import { EndUserLicenseAgreement, EndUserLicenseAgreementService } from './end-user-license-agreement.service';

export const endUserLicenseAgreementResolver: ResolveFn<EndUserLicenseAgreement | RedirectCommand> = () => {
  return inject(EndUserLicenseAgreementService).retrieve();
};
